export default __webpack_public_path__ + "static/photo-bar-9-8272c0df1e888a26d3394432c1ca713e.jpg";